import { useEffect } from 'react';
import { computed, observable } from 'mobx';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import useModal from '@src/utils/hooks/use-modal';
import BaseStore from '@src/utils/store/base-store';
import BookModal from '@src/business-components/modals/book';
import BookModalStore from '@src/business-components/modals/book/store';
import CdkModal from '@src/business-components/cdkey-modal';
import CdkModalStore from '@src/business-components/cdkey-modal/store';
import TeamXcxModal from '@src/business-components/team-xcx-modal';
import TeamXcxModalStore from '@src/business-components/team-xcx-modal/store';
import Video from '@src/components/video';
import { noop } from '@xfe-team/utils/src/common-util';
import $$tracker from '@src/tracker';
import KvVideoStore from './components/kv-video/store';
import message from '@src/components/common-message';
import useMount from '@src/utils/hooks/use-mount';
import { toPage } from '@src/utils/common-util';
import { autobind } from 'core-decorators';

/**
 * 活动状态
 */
export const ACTIVITY_STATUS = {
  open: '1',
  close: '0'
};

class FirstPageStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  videoClose = noop;

  kvVideoStore = new KvVideoStore();

  @observable
  layerData = {
    /**
     * 下载链接
     */
    download_link: 'https://ssglauncher.xoyocdn.com/ssglauncher/ssg/Client/prod/Channel/MechaBREAKCN/SeasunGameInstaller-MechaBREAKCN-mechabreak_cn.exe',
    /**
     * steam商店页链接
     */
    steam_link: '',
    /**
     * xbox商店页链接
     */
    xbox_link: '',
    /**
     * 视频播放封面
     */
    videoCover: '',
    /**
     * 视频播放链接
     */
    videoLink: '',
    /**
     * 活动列表
     */
    activityList: []
  };

  @observable
  localData = {
    /**
     * kv背景图地址
     */
    kvUrl: require('./images/kv.jpg'),
    /**
     * kv视频链接
     */
    // kvVideoLink: 'https://static-omni-mechabreak.seasungames.cn/uploads/202601/%E5%AE%98%E7%BD%91%E8%B5%9B%E5%AD%A3%E8%83%8C%E6%99%AF%E8%A7%86%E9%A2%91.mp4',
    kvVideoLink: '',
    /**
     * 下载按钮文案
     */
    downloadText: '下载游戏',
    /**
     * 预约按钮文案
     */
    appointmentText: '预约游戏',
    /**
     * steam logo
     */
    steamLogo: require('./images/first-page-layer-3.png'),
    /**
     * xbox logo
     */
    xboxLogo: require('./images/first-page-layer-2.png')
  };

  // 礼包活动是否已结束
  @observable activityList = [];

  // 预约人数总数
  @computed
  get appointmentCount() {
    return this.$globalStore.appointmentCount;
  }

  // 是否可以领取福利码
  @computed
  get isCanClaimCdk() {
    return (
      (this.$globalStore.isAppointmentStage && +this.$globalStore.isInSubscribeCodeTime === 1) ||
      (this.$globalStore.isDownloadStage && +this.$globalStore.downLoadGetCodeStatus === 1)
    );
  }

  // 预约弹窗
  bookModal = null;
  bookModalStore = new BookModalStore({
    $main: this,
    closeCallback: () => {
      this.kvVideoStore.play();
    },
    appointmentSuccessCallBack: params => {}
  });

  // cdk弹窗
  cdkModal = null;
  cdkModalStore = new CdkModalStore({
    $main: this
  });

  // 组队小程序
  teamXcxModal = null;
  teamXcxModalStore = new TeamXcxModalStore();

  @autobind
  toDownloadPage() {
    toPage('download', false, this.redirect);
  }

  onVideoPlay = () => {
    const { videoLink } = this.layerData;
    if (videoLink) {
      this.kvVideoStore.pause();
      const { close: videoClose } = Video.append({
        src: videoLink,
        closeCb: () => {
          this.kvVideoStore.play();
        }
      });
      this.videoClose = videoClose;
    }
  };

  // cdk领取
  claimCdk = () => {
    this.cdkModal.open();
  };

  // 立即预约
  book = () => {
    $$tracker.clickLjyy();
    if (this.$globalStore.accountInfo) {
      message.error('您已预约');
    } else {
      this.kvVideoStore.pause();
      this.bookModal.open();
    }
  };

  // 打开组队小程序二维码弹窗
  openTeamXcxQrcodeModal = () => {
    this.teamXcxModal.open();
  };

  use() {
    super.use();

    this.bookModal = useModal(BookModal, { store: this.bookModalStore });
    this.cdkModal = useModal(CdkModal, { store: this.cdkModalStore });
    this.teamXcxModal = useModal(TeamXcxModal, { store: this.teamXcxModalStore });

    const funlinkData = useLayerData('part1');

    useMount(() => {
      return () => {
        this.videoClose?.();
      };
    });

    useEffect(
      () => {
        if (funlinkData) {
          this.layerData = funlinkData;
          this.activityList = funlinkData.activityList || [];
        }
      },
      [funlinkData]
    );
  }
}
export default FirstPageStore;
